function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#445896;}\n\t.st5{fill:#6AABE8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M22,5c-0.2-2.7-1.9-4.2-4-4.6c-0.5-0.1-0.6-0.1-3.2-0.1C5.7,0.3,3.7-0.1,1.9,1.8l0,0C0.2,3.5,0.6,5.4,0.6,11 c0,4.7-0.8,9.4,3.5,10.5c1.3,0.3,13.2,0.3,14.5,0c1.8-0.5,3.2-1.9,3.4-4.4C22,16.7,22,5.3,22,5z M18.8,16.2 c-1.2,3.1-4.4,2.7-7.5,2.7c-3.2,0-6.3,0.3-7.5-2.7C3.3,15,3.4,13.1,3.4,11c0-2.3-0.1-3.9,0.4-5.2c1.2-3,4.3-2.7,7.5-2.7 c3,0,5.1-0.2,6.6,1.3c1.5,1.5,1.3,3.5,1.3,6.6C19.2,13.4,19.3,15,18.8,16.2z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M10.6,4.5L10.6,4.5c-5.3,0-5.8,0.1-5.8,6.5c0,6.3,0.2,6.5,6.5,6.5c3.5,0,6.3,0.4,6.4-3.3 C18.2,3.8,17.3,4.5,10.6,4.5z M11.3,15.1c-2.2,0-4.1-1.8-4.1-4.1S9,7,11.3,7c2.2,0,4.1,1.8,4.1,4.1C15.3,13.3,13.5,15.1,11.3,15.1z  M15.5,7.8c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1C16.5,7.3,16,7.8,15.5,7.8z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st2",
  d: "M11.3,8.4c-3.5,0-3.5,5.3,0,5.3C14.8,13.7,14.8,8.4,11.3,8.4z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "st3",
  points: "11.3,3.1 11.3,3.1 11.3,3.1  "
});

var SvgInstagramIcon = function SvgInstagramIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.8 22.8",
    style: {
      enableBackground: "new 0 0 22.8 22.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("g", null, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.8675,
    y1: 166.5764,
    x2: -52.4254,
    y2: 167.0516,
    gradientTransform: "matrix(0 -42.2827 39.3387 0 -6550.9707 -2214.9919)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDC29"
    }
  }), React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF402D"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D915AF"
    }
  })), _ref3, React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.8671,
    y1: 166.5761,
    x2: -52.425,
    y2: 167.0513,
    gradientTransform: "matrix(0 -42.2827 39.3387 0 -6550.9707 -2214.9919)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDC29"
    }
  }), React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF402D"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D915AF"
    }
  })), _ref4, React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.8674,
    y1: 166.5764,
    x2: -52.4253,
    y2: 167.0516,
    gradientTransform: "matrix(0 -42.2827 39.3387 0 -6550.9707 -2214.9919)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFDC29"
    }
  }), React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FF402D"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D915AF"
    }
  })), _ref5, _ref6));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagramIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram-icon.7c66a9fb.svg";
export { ForwardRef as ReactComponent };